import { type ButtonProps } from '../context';
import LocalButton from './Button';

const BackButton = (props: ButtonProps) => <LocalButton {...props} porscheFallbackIcon="arrow-left" />;

export default BackButton;
